import React from "react";
import "./styles/CalculatorContainer.css";
import Calculator from "../Calculator/Calculator";

const CalculatorContainer = () => {
  return (
    <div className="calc-container">
      <Calculator />
    </div>
  );
};

export default CalculatorContainer;
